// Generated types for RequirementDefinition
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLStructureReadAPI, SysMLStructureWriteAPI } from './sysmlstructure';
import { SysMLStructureReadAPISchemaObject, SysMLStructureWriteAPISchemaObject } from './sysmlstructure';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface RequirementDefinitionReadAPI extends SysMLStructureReadAPI {
  /** Requirement verbatim statement */
  text: string;
}

export interface RequirementDefinitionWriteAPI extends SysMLStructureWriteAPI {
  /** Requirement verbatim statement */
  text: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const RequirementDefinitionReadAPISchemaObject = SysMLStructureReadAPISchemaObject.extend({
  text: z.string(),
}).passthrough();
export const RequirementDefinitionReadAPISchema: z.ZodType<RequirementDefinitionReadAPI> = RequirementDefinitionReadAPISchemaObject;

export const RequirementDefinitionWriteAPISchemaObject = SysMLStructureWriteAPISchemaObject.extend({
  text: z.string(),
}).passthrough();
export const RequirementDefinitionWriteAPISchema: z.ZodType<RequirementDefinitionWriteAPI> = RequirementDefinitionWriteAPISchemaObject;
